import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import AppContext from "../../container/context";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import api from "../../services/api";

export default function DuplicarProduto(props) {
  const history = props.history;
  const { intitular } = useContext(AppContext);
  const [produtoId] = useState(Number(props.match.params.id));
  const [dataAtual] = useState(new Date());
  const { notification } = useContext(AppContext);
  const [produto, setProduto] = useState({});
  const [confirmacaoDuplicacaoProduto, setConfirmacaoDuplicacaoProduto] =
    useState(false);
  const [configuracaoDuplicacaoProduto, setConfiguracaoDuplicacaoProduto] =
    useState({
      copiarImagens: true,
      copiarPrecosEspecificos: true,
      inativarProdutoBase: true,
      copiarPromocoesCondicoesEspeciaisVenda: true,
      copiarExclusividadeVendas: true,
      promocoesInicio:
        dataAtual.getMonth() > 5
          ? `${dataAtual.getFullYear() + 1}-01-01`
          : `${dataAtual.getFullYear()}-07-01`,
      promocoesFim:
        dataAtual.getMonth() > 5
          ? `${dataAtual.getFullYear() + 1}-06-30`
          : `${dataAtual.getFullYear()}-12-31`,
      promocoesHistoricoAPartirDe:
        dataAtual.getMonth() < 8
          ? `${dataAtual.getFullYear()}-06-01`
          : `${dataAtual.getFullYear()}-12-01`,
    });

  useEffect(() => {
    intitular("Produtos - Duplicação");

    carregarProduto();
  }, []);

  const carregarProduto = () => {
    api
      .get("produtos/carregar", { id: produtoId })
      .then((produto) => {
        setProduto(produto);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar produto");
      });
  };

  const iniciarDuplicacaoProduto = (form) => {
    if (
      form.copiarPromocoesCondicoesEspeciaisVenda &&
      (!form.promocoesInicio || !form.promocoesFim)
    ) {
      return notification(
        "warning",
        "Para copiar as promções/cond. especiais, é necessário informar o novo período de vigência."
      );
    }

    setConfirmacaoDuplicacaoProduto(true);
    setConfiguracaoDuplicacaoProduto(form);
  };

  const duplicarProduto = () => {
    const configuracao = configuracaoDuplicacaoProduto;

    configuracao.produtoId = produtoId;

    api
      .post("produtos/duplicar", configuracao)
      .then((produtoDuplicado) => {
        notification("success", "Produto duplicado.");
        setConfirmacaoDuplicacaoProduto(false);
        history.goBack();
      })
      .catch((err) => {
        const { data } = err;
        console.log("data", data);
        switch (data[0]) {
          case 1:
            return notification("error", "Nome inválido");
          case 2:
            return notification(
              "error",
              "Para copiar as promoções, é necessário informar a data de consideração de histórico de pedidos."
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fDuplicacaoEscola = {
    title: "Duplicação de produto",
    form: {
      copiarImagens: {
        label: "Copiar imagens",
        type: "check",
        value: configuracaoDuplicacaoProduto.copiarImagens,
        space: 6,
      },
      copiarPrecosEspecificos: {
        label: "Copiar preços específicos p/ escolas",
        type: "check",
        value: configuracaoDuplicacaoProduto.copiarPrecosEspecificos,
        space: 6,
      },
      inativarProdutoBase: {
        label: "Inativar produto base",
        type: "check",
        value: configuracaoDuplicacaoProduto.inativarProdutoBase,
        space: 6,
      },
      copiarPromocoesCondicoesEspeciaisVenda: {
        label: "Copiar promoções/condições especiais de venda",
        type: "check",
        value:
          configuracaoDuplicacaoProduto.copiarPromocoesCondicoesEspeciaisVenda,
        space: 6,
      },
      copiarExclusividadeVendas: {
        label: "Copiar exclusividades de vendas para escolas",
        type: "check",
        value: configuracaoDuplicacaoProduto.copiarExclusividadeVendas,
        space: 6,
      },
      novoNome: {
        label: "Novo nome",
        type: "text",
        value: configuracaoDuplicacaoProduto.novoNome
          ? configuracaoDuplicacaoProduto.novoNome
          : `${produto.nome} (cópia)`,
        space: 12,
      },
      promocoesInicio: {
        label: "Início das promoções/condições copiadas",
        type: "date",
        value: configuracaoDuplicacaoProduto.promocoesInicio,
        space: 4,
      },
      promocoesFim: {
        label: "Fim das promoções/condições copiadas",
        type: "date",
        value: configuracaoDuplicacaoProduto.promocoesFim,
        space: 4,
      },
      promocoesHistoricoAPartirDe: {
        label: "Para validação de promoções, considerar pedidos a partir de",
        type: "date",
        value: configuracaoDuplicacaoProduto.promocoesHistoricoAPartirDe,
        space: 4,
      },
    },
    submit: {
      label: "Duplicar produto",
      action: iniciarDuplicacaoProduto,
    },
    history,
    close: { label: "Cancelar" },
  };
  return (
    <div>
      <Form formData={fDuplicacaoEscola} />

      <Dialog open={confirmacaoDuplicacaoProduto}>
        <DialogTitle id="scroll-dialog-title">
          Duplicação de produto
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            O produto atual será duplicado e inativado. Deseja continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ color: "white" }}
            variant="contained"
            onClick={() => duplicarProduto()}
          >
            Confirmar
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => setConfirmacaoDuplicacaoProduto(false)}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
